import React, { useEffect } from 'react'
import PropTypes from 'propTypes'
import { cx } from '@emotion/css'
import Container from '../../components/Container'
import styles, { containerDirection, containerWrap } from './styles'

const Content = ({ direction, wrap, children, className }) => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('The `Content` component is deprecated, rather use `ContentSection`.')
    }
  }, [])

  return (
    <section className={cx(styles.wrapper, className)}>
      <Container className={cx(styles.container, containerDirection(direction), containerWrap(wrap))}>{children}</Container>
    </section>
  )
}

Content.propTypes = {
  direction: PropTypes.oneOf(['', 'vertical', 'horizontal']),
  wrap: PropTypes.oneOf(['', 'initial', 'wrap']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
}

Content.defaultProps = {
  direction: 'vertical',
  wrap: 'initial',
}

export default Content
